export default __webpack_public_path__ + "static/media/reports-5.bf3abfb3.png";